import React, { Component } from "react";
import { Image } from "react-bootstrap";
import hyperlinks from "../../../src/util/hyperlinks";



export default class BecomeUtilityMember extends Component {
    render() {
        return (
            <div>
                <h2>Becoming A Member</h2>
                <p>
                    The selection process for potential members of the group involves four stages:
                </p>

                <p>
                    <span className="blue-text"><strong>Nomination:</strong></span> A prospective member of the group needs first to be nominated by an existing member who believes that the utility has an important experience or innovation to share with the group.
                </p>

                <p>
                    <span className="blue-text"><strong>Application:</strong></span> The nominated utility is then approached by the staff of the Global Water Leaders Group to inform the utility of its nomination and seek a demonstration of its commitment to join, if chosen, and to provide additional information in support of the application. This information is collated into an application which is shared with the existing members of the group.
                </p>

                <p>
                    <span className="blue-text"><strong>Screening and feedback:</strong></span> If there are objections to the application, the grounds for these objections will be communicated to the applicant, with suggested actions that might be undertaken so that the utility may join the group in future.
                </p>

                <p>
                    <span className="blue-text"><strong>Public presentation:</strong></span> The leader of the applicant utility should give public presentation of his or her utility's achievements to the group and answer questions from existing members at a Leading Utilities of the World event.
                </p>

                <p>
                    <span className="blue-text"><strong>Joined by acclamation:</strong></span> Assuming that there are no further objections at the presentation stage, the applicant joins the group by acclamation (i.e. a round of applause) and is presented with the Golden Tap trophy signifying membership. The utility is allowed to use the Leading Utilities of the World insignia on its website and stationery for a period of five years until its membership is renewed. It is hoped that the screening process is sufficiently thorough to ensure that no utilities are rejected at this stage, but should doubts be raised as to the suitability for membership which cannot be sufficiently answered, the candidate may be given a certificate of commendation and invited to reapply at a later date.
                </p>

                <Image src="/assets/certificate_trophy_budapest-d7edf1f52c676ba9691d6895eff2e804c6e7c9deaf94b268c0872a9f8a7aa55e.jpg" className="img-responsive" style={{ maxWidth: "75%", margin: "auto" }} />

                <h2>Eligibility</h2>

                <p>
                    To be recognised as a Leading Utility of the World requires two things: <br /><span className="blue-text indent"><strong>a) outstanding achievement and innovation in at least three aspects of utility management</strong></span> <br /><span className="blue-text indent"><strong>b) an ambition to continue to drive performance in the years to come</strong></span>
                </p>

                <p>
                    The categories of utility management innovation to be assessed can be found <a href={hyperlinks["innovationAreas"]}>here</a>.
                </p>

                <p>
                    Members should be able to demonstrate that they have undertaken actions in at <span className="blue-text"><strong>least three of these areas</strong></span> which are of global significance in terms of the challenges overcome to deliver the goal. They should also outline which areas of performance they are seeking to improve in future, and report back on these actions after five years to retain their membership.
                </p>

                <p className="direct-to-contact">
                    Interested in becoming a member? Contact the LUOW team <a href={hyperlinks["contactUs"]}>here</a>.
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/BecomeUtilityMember.jsx.erb